import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Text = styled.textarea`
  background: transparent;
  border: ${({ theme }) => `1px solid ${theme.colors.lightGray}`};
  box-shadow: none;
  width: 100%;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.black};
  min-height: 130px;
  padding: 15px;
  border-radius: 5px;
  resize: none;

  &:focus {
    outline: none;
  }
`;

export default function TextArea(props) {
  const { name, defaultValue, register } = props;
  return (
    <Text {...props} name={name} defaultValue={defaultValue} ref={register} />
  );
}

TextArea.defaultProps = {
  defaultValue: null,
  register: null,
};

TextArea.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  register: PropTypes.func,
};
